import FpuiPackageEditor from './FpuiPackageEditor.vue'

export default FpuiPackageEditor
